import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import React from "react";

const boysHistory = [
    { team: 'Rapids Black', victories: '10' },
    { team: 'Scarlet Knights', victories: '4'},
    { team: 'RSD', victories: '2'},
    { team: 'Union Springs', victories: '1'},
    { team: 'Freedom Academy', victories: '1'}
];
const girlsHistory = [
    { team: 'Scarlet Knights', victories: '10' },
    { team: 'Rapids Black', victories: '10' },
    { team: 'Cornerstone', victories: '1' }
];

export default function PastResults()  {

    return (
        <Box sx={{ paddingTop: '20px', width: '100%', maxWidth: '1200px'}}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-evenly', width: '100%'  }}>
                <div>
                    <Typography variant='h5'><p>Boys Championship Summary</p></Typography>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Team</TableCell>
                                    <TableCell align='center'>Victories</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {boysHistory.map((history) => (
                                    <TableRow
                                        key={history.team}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            {history.team}
                                        </TableCell>
                                        <TableCell align='center'>{history.victories}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Typography variant='h6' sx={{paddingTop: '10px'}}><p>Boys Championship History</p></Typography>
                    <ul style={{ textAlign: 'left'}}>
                        <li>2024 - Scarlet Knights defeated Rapids Grey 2-1.</li>
                        <li>2024 - Union Springs defeated Rapids Grey 2-0.</li>
                        <li>2023 - Rapids Black defeated Cornerstone 4-0.</li>
                        <li>2022 - Rapids Black defeated Cornerstone 2-1.</li>
                        <li>2021 - Rapids Black defeated Cornerstone 7-0.</li>
                        <li>2020 - Rapids Black defeated Scarlet Knights 3-0.</li>
                        <li>2019 - Rapids Black defeated Scarlet Knights 2-0.</li>
                        <li>2018 - Rapids Black defeated Scarlet Knights 3-0.</li>
                        <li>2017 - Freedom Academy defeated Rapids Black 2-1.</li>
                        <li>2016 - Rapids Black defeated Scarlet Knights 5-0.</li>
                        <li>2015 - Rapids Black defeated RSD 3-2.</li>
                        <li>2014 - Rapids Black defeated Freedom Academy 3-0.</li>
                        <li>2013 - RSD defeated Freedom Academy 1-0 in overtime.</li>
                        <li>2012 - Scarlet Knights defeated RSD 2-1</li>
                        <li>2011 - RSD defeated USA 4-3</li>
                        <li>2010 - Rapids Black defeated ??</li>
                        <li>2009 - Scarlet Knights defeated RSD 3-0.</li>
                        <li>2008 - Scarlet Knights defeated ??</li>
                    </ul>
                </div>
                <div>
                    <Typography variant='h5'><p>Girls Championship Summary</p></Typography>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Team</TableCell>
                                    <TableCell align='center'>Victories</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {girlsHistory.map((history) => (
                                    <TableRow
                                        key={history.team}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            {history.team}
                                        </TableCell>
                                        <TableCell align='center'>{history.victories}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Typography variant='h6' sx={{paddingTop: '10px'}}><p>Girls Championship History</p></Typography>
                    <ul style={{ textAlign: 'left'}}>
                        <li>2024 - Rapids Black defeated Intensity 3-0.</li>
                        <li>2024 - Scarlet Knights defeated Rapids Grey 1-0.</li>
                        <li>2023 - Rapids Black defeated Scarlet Knights 5-0.</li>
                        <li>2022 - Rapids Black defeated Cornerstone 1-0.</li>
                        <li>2021 - Cornerstone defeated Rapids Black in penalty kicks.</li>
                        <li>2020 - Rapids Black defeated Cornerstone 1-0.</li>
                        <li>2019 - Rapids Black defeated Scarlet Knights 1-0.</li>
                        <li>2018 - Rapids Black defeated Scarlet Knights 2-0.</li>
                        <li>2017 - Rapids Black</li>
                        <li>2016 - Scarlet Knights</li>
                        <li>2015 - Scarlet Knights</li>
                        <li>2014 - Scarlet Knights</li>
                        <li>2013 - Rapids Black</li>
                        <li>2012 - Scarlet Knights</li>
                        <li>2011 - Scarlet Knights</li>
                        <li>2010 - Scarlet Knights</li>
                        <li>2009 - Scarlet Knights</li>
                        <li>2008 - Rapids Black</li>
                        <li>2007 - Scarlet Knights</li>
                        <li>2006 - Rapids Black</li>
                        <li>2005 - Scarlet Knights</li>
                    </ul>
                </div>
            </Box>
        </Box>
    )
}
